<template>
  <v-container fluid>
    <v-alert type="error" max-width="600" icon="mdi-close-octagon" class="mx-auto mt-5 material-icons-outlined" dark
      prominent>
      <h2>You do not have access to the {{ permit ? permit : 'current module' }}</h2>
      The {{ permit ? permit : 'current module' }} is not available for your user type. Please contact an administrator
      if you want to change your user type.
      <!--
        //TODO: improve text and add translation support.
      -->
    </v-alert>
  </v-container>
</template>


<script>
export default {
  name: 'UnAuthorizedAccess',
  props: {},
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {
    permit() {
      return this.$store.getters["navstore/BrokenPermitText"];
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>